import AppointmentInfo from "./AppointmentInfo";
export default AppointmentInfo;
